import {
  del,
  get,
  patch,
  post,
  type RequestConfig,
} from "../shared/api-client";
import type {
  ApiItemResponse,
  ListQuery,
  PaginatedResult,
} from "@project/types/location";
import type { Festival, FestivalPayload } from "@project/types/festival";
import {
  JIVANDHARA_BASE,
  SILENT_LIST,
  fetchListPage,
  unwrapItem,
} from "./list-api-helpers";

const BASE = `${JIVANDHARA_BASE}/festivals`;
const SILENT: RequestConfig = { showNotification: false };

class FestivalService {
  listFestivalsPage = (
    query: ListQuery = {}
  ): Promise<PaginatedResult<Festival>> => {
    return fetchListPage<Festival>(`${BASE}/`, query);
  };

  getFestival = async (id: number): Promise<Festival | undefined> => {
    const data = await get<ApiItemResponse<Festival> | Festival>(
      `${BASE}/${id}/`,
      SILENT_LIST
    );
    return unwrapItem(data);
  };

  createFestival = async (
    payload: FestivalPayload
  ): Promise<Festival | undefined> => {
    const data = await post<
      ApiItemResponse<Festival> | Festival,
      FestivalPayload
    >(`${BASE}/`, payload, SILENT);
    return unwrapItem(data);
  };

  updateFestival = async (
    id: number,
    payload: Partial<FestivalPayload>
  ): Promise<Festival | undefined> => {
    const data = await patch<
      ApiItemResponse<Festival> | Festival,
      Partial<FestivalPayload>
    >(`${BASE}/${id}/`, payload, SILENT);
    return unwrapItem(data);
  };

  deleteFestival = async (id: number): Promise<void> => {
    await del(`${BASE}/${id}/`, SILENT);
  };
}

export const festivalService = new FestivalService();
